import SyllabusVM from './syllabus-vm';
import Vue from 'vue';
import 'libs/vue-extensions';

export default {
  prepUI: function() {}, 
  init: function(ele) {
    console.log('Kadenze.CourseSyllabusVM Init function called');
    const vm = new Vue(SyllabusVM);
    vm.bindData(JSON.parse(ele.dataset.course));
    vm.$mount(ele);
  }
};
